/**
 * useVoiceTTS - TTS "is speaking" state for voice conversation
 *
 * Holds isSpeaking state and a ref so STT/Flux handlers can gate input without
 * stale closures. The actual play/stop logic stays in the caller (VoiceConversation)
 * which sets speaking via setSpeaking when TTS starts/ends.
 *
 * @returns {{ isSpeaking: boolean, isSpeakingRef: React.MutableRefObject<boolean>, setSpeaking: (value: boolean) => void }}
 */
import { useState, useRef, useCallback } from 'react';

export function useVoiceTTS() {
  const [isSpeaking, setIsSpeaking] = useState(false);
  const isSpeakingRef = useRef(false);

  const setSpeaking = useCallback((value) => {
    isSpeakingRef.current = value;
    setIsSpeaking(value);
  }, []);

  return { isSpeaking, isSpeakingRef, setSpeaking };
}
